import { isRouteErrorResponse, useRouteError } from 'react-router-dom';
import { Alert } from '@cmsgov/design-system';

import { Button, ButtonVariation } from '../components/Button';

function ErrorPage() {
  const baseTestId = 'error-page';
  const error = useRouteError();
  let errorMessage: string;
  let errorStatus: string | number = 'Error';

  if (isRouteErrorResponse(error)) {
    errorMessage = error.statusText || error.data?.message || 'An unexpected error occurred';
    errorStatus = error.status;
  } else if (error instanceof Error) {
    errorMessage = error.message;
  } else if (typeof error === 'string') {
    errorMessage = error;
  } else {
    errorMessage = 'An unexpected error occurred';
  }

  console.error('Application Error:', error);

  return (
    <div
      className='ds-base'
      data-testid={baseTestId}>
      <div
        className='ds-l-container'
        data-testid={`${baseTestId}-container`}>
        <div
          className='ds-u-padding--3'
          data-testid={`${baseTestId}-content`}>
          <div
            className='ds-u-margin-bottom--3'
            data-testid={`${baseTestId}-header`}>
            <h1
              className='ds-text-heading--2xl ds-u-margin-bottom--2'
              data-testid={`${baseTestId}-title`}>
              {typeof errorStatus === 'number' ? `${errorStatus} Error` : 'Unexpected Error'}
            </h1>

            <Alert
              data-testid={`${baseTestId}-alert`}
              heading='Something went wrong'
              variation='error'>
              <p className='ds-u-margin-bottom--2'>
                <strong>Error Details:</strong> {errorMessage}
              </p>
              {process.env.NODE_ENV === 'development' && error instanceof Error && error.stack && (
                <details className='ds-u-margin-top--2'>
                  <summary className='ds-u-cursor--pointer'>View Stack Trace</summary>
                  <pre className='ds-u-margin-top--2 ds-u-padding--2 ds-u-border--1 ds-u-overflow--auto'>
                    <code>{error.stack}</code>
                  </pre>
                </details>
              )}
            </Alert>
          </div>

          <div
            className='ds-u-margin-top--3'
            data-testid={`${baseTestId}-actions`}>
            <Button
              isAutoWidth
              data-testid={`${baseTestId}-home-link`}
              href='/'
              variation={ButtonVariation.SOLID}>
              Return to Home
            </Button>
          </div>
        </div>
      </div>
    </div>
  );
}

export default ErrorPage;
